import { PumpMotoLogPagination } from '@/module/pump_moto_log/domain/model/pump_moto_log_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export type PumpMotoLogPaginationParams = Omit<Pagination, "search"> & {
  placeID: number;
  startDate?: string;
  endDate?: string;
}

export interface FetchPumpMotoLogRepository {
    (pagination: PumpMotoLogPaginationParams): Promise<PumpMotoLogPagination>
}

const fetchEventRepository = (axios: AxiosInstance): FetchPumpMotoLogRepository => async (pagination: PumpMotoLogPaginationParams) => {
    try {
        const response: AxiosResponse = await axios.get('/pump-moto-log', {
            params: pagination
        })

        const result: PumpMotoLogPagination = response.data
        return result
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchEventRepository
